export default "__VITE_ASSET__etSSE5Tx__"